import Schema from 'AppReact/schema';
import { tableOrder, property } from 'types';

export default {
  order: Schema(tableOrder, 'object', { defaultValue: {} }),
  selectedTab: Schema('string', 'primitive-nullable', { defaultValue: null }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  ref: Schema({}, 'object', { defaultValue: null }),
  swipe: Schema('integer', 'primitive', { defaultValue: 0 })
}